import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime';

const operationsGenerator = createOperationsGenerator();

export default defineProvider<{ baseURL?: string }>({
  getImage(src, { modifiers, baseURL }) {
    const operationsConfig: {
      height?: string;
      width?: string;
      mode?: string;
    } = {
      mode: 'fill',
    };

    if (modifiers.height !== undefined) {
      operationsConfig.height = String(modifiers.height);
    }

    if (modifiers.width !== undefined) {
      operationsConfig.width = String(modifiers.width);
    }

    const operations = operationsGenerator(operationsConfig);

    const url = `${baseURL ? baseURL : ''}${src + (operations ? '?' + operations : '')}`;

    return {
      url,
    };
  },
});
